module.exports = __webpack_public_path__ + "static/media/item_2_3.0c5ec718.png";